import { Container, Row, Col } from 'react-bootstrap';
import React from 'react';
import GpxDownload from '../../assets/gpx/gpx-29k.gpx';
const RouteGpx = ({language}) => {
    return (
      <section className="route-gpx">
        <h5><span>{language === "Chinese" ? "GPX地圖" : "GPX Map"}</span></h5>
        <Container>
          <Row className='align-items-center'>
            <Col md={3}>
            <h3 className='text-center'><a href={GpxDownload} download={'letape-sunmoonlake-29k-gpx'}>{language === "Chinese" ? "★點我下載GPX檔★" : "★ Download the GPX File ★"}</a></h3>
              <h4 className='text-center'>{language === "Chinese" ? "如何匯入GPX檔至Google Maps？三步驟輕鬆做！" : "How to import a GPX file into Google Maps in 3 easy steps"}</h4>
              <div className="gpx-bx">
                <p>{language === "Chinese" ? "❶ 步驟 1" : "❶ Step 1"}</p>
                <p>{language === "Chinese" ? "登入 Google Maps，點選畫面左上角「Google My Maps」左邊的選單，再點選「建立新地圖」。" : `Sign in to Google Maps, open the menu at the top left next to "Google My Maps", and select "Create a new map".`}</p>
              </div>
              <div className="gpx-bx">
                <p>{language === "Chinese" ? "❷ 步驟 2" : "❷ Step 2"}</p>
                <p>{language === "Chinese" ? "點選「匯入」，找到你取得的 GPX 檔案並匯入。點選「無標題的地圖」輸入正確名稱。" : `Click "Import", locate the GPX file you downloaded, and import it. Then click "Untitled map" and give the map a name.`}</p>
              </div>
              <div className="gpx-bx">
                <p>{language === "Chinese" ? "❸ 步驟 3" : "❸ Step 3"}</p>
                <p>{language === "Chinese" ? "開啟手機 Google Maps App，點選畫面下方中間的「已儲存」，將上方清單向左滑動即可找到地圖。" : `Open the Google Maps app on your phone, tap "Saved" at the bottom center of the screen, and swipe the list at the top to the left to find your map.`}</p>
              </div>
            </Col>
            <Col md={9} className='gpx-map'>
              <iframe title="28K The Ride" src="https://ridewithgps.com/embeds?type=route&id=47303692&title=29K%20The%20Ride%20&sampleGraph=true&distanceMarkers=true&showPhotos=true"
                ></iframe>
            </Col>
          </Row>
        </Container>
      </section>
    )
}


export default RouteGpx